import { render, staticRenderFns } from "./RegistrationProfileSetting.vue?vue&type=template&id=0ab95522&scoped=true&"
import script from "./RegistrationProfileSetting.vue?vue&type=script&lang=js&"
export * from "./RegistrationProfileSetting.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationProfileSetting.vue?vue&type=style&index=0&id=0ab95522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab95522",
  null
  
)

export default component.exports